<template>
  <div>
    <b-button
      v-b-toggle.sidebar-send-invoice
      variant="primary"
      :disabled="disabled"
      block
      @click="generateReport()"
    >
      {{ $t("common.print") }}
    </b-button>
    <vue-html2pdf
      ref="printTests"
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="0"
      filename="patient card"
      :pdf-quality="2"
      :manual-pagination="true"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="794px"
      pdf-margin="0"
    >
      <!-- Printable content -->
      <div
        slot="pdf-content"
        class="pdf-wrapper"
      >
        <section
          v-for="(pageData, pageIndex) in paginatedData"
          :key="pageIndex"
          :class="[
            'font-modify',
            'test-background',
            'pdf-page',
            { 'pdf-page-first': pageIndex === 0 },
          ]"
        >
          <!-- <div class="header p-3">
            <h1 dir="rtl" class="font-modify">مختبر</h1>
            <h2 class="subheader-title">{{ $brand.nameArFull }}</h2>
            <h2 class="subheader-title">للتحليلات المرضية و الهرمونات</h2>
          </div> -->

          <div
            class="info-header"
            style="margin-top: 260px; padding: 0 20px"
          >
            <div class="patient-info">
              <div class="info-row">
                <span class="info-label">Name:</span>
                <span class="arabic-name-full ml-2">
                  <span class="arabic-name-isolated">
                    {{ getNestedProperty(patientInfo, "patient.name") }}
                  </span>
                </span>
              </div>
              <div class="info-row">
                <span class="info-label">Gender / Age:</span>
                <span class="arabic-text ml-2">
                  {{ patientAge }} Years /
                  {{ getNestedProperty(patientInfo, "patient.gender") }}
                </span>
              </div>
              <div class="info-row">
                <span class="info-label">Referred By:</span>
                <span class="arabic-text ml-2">
                  {{ getNestedProperty(patientInfo, "referred_by") }}
                </span>
              </div>
            </div>
            <div class="date-info">
              <span class="arabic-text">التاريخ:</span>
              {{ getCurrentDate() }}
            </div>
          </div>

          <table class="styled-table">
            <thead>
              <tr>
                <th>Test Name</th>
                <th>Result</th>
                <th>Unit</th>
                <th>Normal Range</th>
                <!-- <th>Result - Normal</th> -->
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(test, index) in pageData"
                :key="index"
              >
                <td>{{ getNestedProperty(test, "test.name") }}</td>
                <td>{{ getNestedProperty(test, "result") }}</td>
                <td>
                  {{
                    getNestedProperty(test, "unit.name")
                      ? getNestedProperty(test, "unit.name")
                      : "-"
                  }}
                </td>
                <td>
                  {{ getNestedProperty(test, "writeTest.min") }} -
                  {{ getNestedProperty(test, "writeTest.max") }}
                </td>
                <!-- <td>{{ test.result_as_to_normal_range }}</td> -->
              </tr>
            </tbody>
          </table>

          <!-- <div class="footer-info">
            <div v-if="$brand.phone">{{ $brand.phone }}</div>
            <div v-if="$brand.addressAr" class="location-info">
              <span>{{ $brand.addressAr }}</span>
            </div>
          </div> -->
        </section>
      </div>
    </vue-html2pdf>
  </div>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf'
import { BButton } from 'bootstrap-vue'

export default {
  components: {
    VueHtml2pdf,
    BButton,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
    patientInfo: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    patientAge() {
      if (!this.patientInfo.patient.birth_date) return null
      const birthDate = new Date(this.patientInfo.patient.birth_date)
      const today = new Date()
      let age = today.getFullYear() - birthDate.getFullYear()
      const monthDifference = today.getMonth() - birthDate.getMonth()
      if (
        monthDifference < 0
        || (monthDifference === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--
      }
      return age > 0 ? age : 1
    },
    paginatedData() {
      const itemsPerPage = 13
      const pages = []
      for (let i = 0; i < this.data.length; i += itemsPerPage) {
        pages.push(this.data.slice(i, i + itemsPerPage))
      }
      // If no data, return at least one empty page
      return pages.length > 0 ? pages : [[]]
    },
  },
  methods: {
    getNestedProperty(obj, path, defaultValue = '') {
      const result = path
        .split('.')
        .reduce(
          (acc, part) => (acc && acc[part] !== undefined && acc[part] !== null
            ? acc[part]
            : defaultValue),
          obj,
        )
      // console.log("result", result);
      return result
    },
    generateReport() {
      this.$refs.printTests.generatePdf()
    },
    getCurrentDate() {
      const today = new Date()
      const year = today.getFullYear()
      const month = String(today.getMonth() + 1).padStart(2, '0')
      const day = String(today.getDate()).padStart(2, '0')
      return `${year}/${month}/${day}`
    },
  },
}
</script>

<style scoped>
.arabic-text {
  direction: rtl;
  unicode-bidi: embed;
  /* Use a font that supports Arabic */
}

.arabic-name-full {
  direction: rtl;
  unicode-bidi: embed;
  display: inline-block;
  text-align: right;
}

.arabic-name-isolated {
  direction: rtl;
  unicode-bidi: isolate;
  display: inline;
}
.font-modify {
  letter-spacing: normal !important;
}
/* General Styling for PDF */
.pdf-content {
  /* font-family: Arial, sans-serif; */
}
.header {
  text-align: center;
  margin-bottom: 20px;
}
.header-title {
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 5px;
}
.subheader-title {
  font-size: 24px;
  font-weight: 600;
}
.info-header {
  display: flex;
  justify-content: space-between;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
}

.patient-info {
  flex: 1;
}

.info-row {
  margin-bottom: 8px;
  display: flex;
  align-items: baseline;
}

.info-row:last-child {
  margin-bottom: 0;
}

.info-label {
  font-weight: bold;
  min-width: 120px;
  display: inline-block;
}

.date-info {
  text-align: right;
  font-weight: bold;
}
.styled-table {
  width: calc(100% - 40px);
  margin: 0 20px 20px 20px;
  border-collapse: collapse;
  font-size: 16px;
  font-weight: bold;
}
.styled-table th,
.styled-table td {
  border: 1px solid #000;
  padding: 8px;
  text-align: center;
}
.styled-table th {
  background-color: #f3f3f3;
  font-weight: bold;
}
.footer-info {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  font-weight: bold;
  padding: 0 20px;
}
.location-info {
  display: flex;
  gap: 8px;
}

/* Background Image Styling */
.test-background {
  background-image: url("~@/assets/images/pdfBg/svgPrintPage.svg");
  background-size: 100% 100%;
  background-position: top left;
  background-repeat: no-repeat;
  background-attachment: fixed;
  min-height: 1123px;
  height: 1123px;
  width: 794px;
  position: relative;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  overflow: hidden;
}

.pdf-wrapper {
  margin: 0;
  padding: 0;
  width: 794px;
}

.pdf-page {
  page-break-inside: avoid;
  break-inside: avoid;
  margin: 0;
  padding: 0;
  display: block;
  width: 794px;
  position: relative;
}

.pdf-page:not(.pdf-page-first) {
  page-break-before: always;
  break-before: page;
  margin-top: 0;
}

.pdf-page-first {
  page-break-before: auto;
  break-before: auto;
}

@media print {
  .pdf-wrapper {
    margin: 0;
    padding: 0;
  }

  .pdf-page {
    page-break-inside: avoid;
    break-inside: avoid;
    height: 1123px;
    max-height: 1123px;
    overflow: hidden;
    margin: 0;
    padding: 0;
    width: 794px;
    position: relative;
  }

  .pdf-page:not(.pdf-page-first) {
    page-break-before: always;
    break-before: page;
    margin-top: 0;
  }

  .pdf-page-first {
    page-break-before: auto;
    break-before: auto;
  }

  .pdf-page:last-child {
    page-break-after: auto;
    break-after: auto;
  }
}
</style>
